
import { defineComponent } from 'vue';
import { cefRequest } from "../../utils/cef";

const USERNAME_PATTERN = /^[A-Za-z0-9_]{3,16}$/;

export default defineComponent({
  name: 'gamepassPage',
  data() {
    return {
      ingamepass: false,
      pseudonyme: '',
      error: '',
    };
  },
  computed: {
    isValid(): boolean {
      return USERNAME_PATTERN.test(this.pseudonyme);
    },
    liveError(): string {
      if (!this.pseudonyme) {
        return '';
      }
      const bad = this.pseudonyme.match(/[^A-Za-z0-9_]/);
      if (bad) {
        return `Caractère non autorisé : « ${bad[0]} »`;
      }
      if (this.pseudonyme.length < 3) {
        return 'Au moins 3 caractères.';
      }
      return '';
    },
    displayError(): string {
      return this.error || this.liveError;
    },
  },
  watch: {
    pseudonyme() {
      this.error = '';
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Login' });
    },
    async gamepass() {
      if (this.ingamepass) {
        return;
      }
      if (!this.isValid) {
        this.error = 'Le pseudonyme doit faire 3 à 16 caractères (lettres, chiffres et _).';
        return;
      }

      this.error = '';
      this.ingamepass = true;
      try {
        const response = await cefRequest("SETTER", "GAMEPASS", {
          username: this.pseudonyme,
        });
        if (response.status !== 200) {
          this.error = 'Ce pseudonyme n\'est pas disponible, essayez-en un autre.';
        }
      } catch (e) {
        this.error = 'Une erreur est survenue, veuillez réessayer.';
      } finally {
        this.ingamepass = false;
      }
    },
  },
});
